<div class="main" *ngIf="userTypeRole === 'Beneficiary'">
    <div class="page-caption">
        <h5 class="common-bene-class-for-translation"> Login and Security </h5>
    </div>
    
    <div class="main-content">
        <div class="card user-name-card card-body">
    
            <div class="flex-row bold-bottom-border pb-20">
                <div>
                    <div>
                        <h6 class="common-bene-class-for-translation"> User Name / ID </h6>
                    </div>
                    <div class="un-sub-ttle common-bene-class-for-translation">Update your User Name / ID</div>
                </div>
                <div class="flex-col align-right">
                    <div class="text-direction-close">
                        <a class="anchor-close" data-toggle="collapse" (click)="toggleView('usnmBlock')"
                            href="#collapseBox1" role="button">
                            <span class="common-bene-class-for-translation" [ngClass]="{'noDipsplay': usnmBlockOpen }"> Change</span>
                            <span class="common-bene-class-for-translation" [ngClass]="{'noDipsplay': !usnmBlockOpen }">Close</span>
                        </a>
                    </div>
                    <div class="last-changed"></div>
                </div>
            </div>
    
            <div class="collapse" id="collapseBox1">
                <div class="row pt-1 mb-2 border-top"></div>
                <div>
                    <h6 class=" mb-4 common-bene-class-for-translation">
                        User names you are using to log in to your account
                    </h6>
                </div>
                <div class="margin-box1">
                    <!---- listing  begin----->
                    <ng-container *ngIf="userListing.length>0;else noData">
                    <ng-container *ngFor="let item of userListing; let idx = index;">
                        <div class="flex-row mt-2 dotted-bottom-border py-3"
                            [ngClass]="{'dotted-bottom-border': editId != idx }">
    
                            <div class="col-md-3 form-group">
    
                                <label *ngIf="item.isMasterAccount == 0" for="username[idx]" class="common-bene-class-for-translation">Company Account  User Name / ID</label>
                                <label *ngIf="item.isMasterAccount == 1" for="username[idx]" class="common-bene-class-for-translation">Personal Account  User Name / ID</label>
    
                                <input minLength="5" maxlength="12" pattern="^([a-zA-Z0-9._-]{5,12})$"
                                    [disabled]="true"
                                    required *ngIf="editId == idx" [(ngModel)]="item.username"
                                    name="username[idx]" class="form-control" [ngClass]="{'inputError':errorMessage !=''}"
                                    placeholder="Username / ID">
                                <h6 *ngIf="editId != idx" class="text-left">{{item.username}}</h6>
    
                                <div class="form-group row pl-0 mt-4" *ngIf="editId == idx">
                                    <div class="col-9 pl-0">
                                    <label for="password" class="common-bene-class-for-translation">Enter your current Password*</label>
                                    <div class="position-relative">
                                    <input type="text" class="im-input" 
                                    [type]="item.pwd_hide ? 'text':'password'"
                                    [disabled]="!item.passwordEnabled"
                                    pattern="(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}"
                                    [(ngModel)]="item.password" placeholder="Password">
                                    <mat-icon style="top:0px;right:10px;position:absolute" matTooltip="Show/Hide" class="mt-1" matSuffix (click)="item.pwd_hide  = !item.pwd_hide ">
                                      {{item.pwd_hide ?'visibility':'visibility_off'}}
                                     </mat-icon>
                                    </div>
                                </div>
                                <div class="col-3">
                                    <button type="button" class="back-button position-absolute" style="bottom:4px;"
                                    (click)="verifyPassword(item)">
                                    <span class="common-bene-class-for-translation">Verify</span>
                                </button>
                            </div>
                                    
                                  </div>
    
                            </div>
    
                            <div class="flex-col ml6em col-3" *ngIf="item.isMasterAccount == 0">
                                <div class="mb2em common-bene-class-for-translation">Company Name</div>
                                <div class="bold-grey-text text-left">{{item.companyName}}</div>
    
                                <div class="form-group row pl-0 mt-4 pt-4 col-10" *ngIf="item.isMasterAccount == 0 && !item.userNameEnabled" >
                                    <label for="newusername[idx]" class="common-bene-class-for-translation">Company Account New Username / ID</label>
                                <input minLength="5" maxlength="12" style="margin-bottom:1rem"
                                    [disabled]="item.userNameEnabled"
                                    required *ngIf="editId == idx" [(ngModel)]="item.newusername"
                                    name="username[idx]" class="form-control" [ngClass]="{'inputError':errorMessage !=''}"
                                    placeholder="Username / ID">
                                <app-userId-validation 
                                    *ngIf="item.newusername"
                                    [userId] = "item.newusername"
                                    (isValid)= "enableSaveButton($event,item)" >
                                   </app-userId-validation>    
                                <h6 *ngIf="editId != idx" class="text-left">{{item.newusername}}</h6>
                                </div>    
    
                            </div>
                            <div class="flex-col ml6em col-2" *ngIf="item.isMasterAccount == 0">
                                <div class="mb2em common-bene-class-for-translation">Communication Email ID</div>
                                <div class="bold-grey-text text-left">{{item.commEmail}}</div>  
                            </div>
                            <div class="flex-col ml6em col-3" *ngIf="item.isMasterAccount == 1">
                                <div class="form-group row pb-5 position-absolute col-9" *ngIf="item.isMasterAccount == 1 && !item.userNameEnabled" >
                                    <label for="newusername[idx]" class="common-bene-class-for-translation">Personal Account New Username / ID</label>
                                <input minLength="5" maxlength="12"
                                    [disabled]="item.userNameEnabled"
                                    required *ngIf="editId == idx" [(ngModel)]="item.newusername"
                                    name="username[idx]" class="form-control" [ngClass]="{'inputError':errorMessage !=''}"
                                    placeholder="Username / ID">
                                <app-userId-validation 
                                    *ngIf="item.newusername"
                                    [userId] = "item.newusername"
                                    (isValid)= "enableSaveButton($event,item)" >
                                   </app-userId-validation>        
                                <h6 *ngIf="editId != idx" class="text-left">{{item.newusername}}</h6>
                                </div>    
    
                            </div>
    
                            <div class="edit-btn-float-right flex-col">
                                <div class="flex-row flex-end">
    
                                    <button class="back-button button-width-icon-left btn-content-align btn btn-light" (click)="setEditIndex(idx)"
                                        *ngIf="editId != idx">
                                        <span class="material-icons mat-icon Verify" matTooltip="Edit">edit</span>
                                        <span class="common-bene-class-for-translation">Edit</span>
                                    </button>
    
                                    <button type="button" class="back-button close-button button-width-icon-left mr-2"
                                        (click)="setEditIndex(null)" *ngIf="editId == idx">
                                        <span class="material-icons  mat-icon Verify" matTooltip="stop editing">close</span>
                                        <span class="common-bene-class-for-translation">Close</span>
                                    </button>
    
                                    <button type="button" class="btn-success button-width-icon-left  btn-content-align btn"
                                        [disabled]="!item.saveEnable"
                                        (click)="saveUserName(item)" *ngIf="editId == idx && item.isMasterAccount == 0">
                                        <span class="material-icons  mat-icon Verify" matTooltip="Save">save</span>
                                        <span class="common-bene-class-for-translation">Save</span>
                                    </button>
    
                                    <button type="button" class="btn-success button-width-icon-left  btn-content-align btn"
                                        (click)="saveUserName(item)" *ngIf="editId == idx  && item.isMasterAccount == 1">
                                        <span class="material-icons  mat-icon Verify" matTooltip="Save">save</span>
                                        <span class="common-bene-class-for-translation">Save</span>
                                    </button>
                                </div>
    
                                <div class="last-changed mt-1">
                                    <span *ngIf="item.lastUpdatedDate" class="common-bene-class-for-translation">Last changed on :
                                        {{ formatDate(item['lastUpdatedDate']) }}</span>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="editId == idx" class="dotted-bottom-border flex-col pt-2">
                            <div class="ml-3  mt-1 errorMessage">
                                <div *ngIf="errorMessage !=''"> {{errorMessage}}</div>
                            </div>
                            <div class="mt-1 ml-3 description">
                                <div *ngIf="item.isMasterAccount == 0">
                                  <span  class="common-bene-class-for-translation">  This username is linked with your current petitioner. Changing this username you will no
                                    longer be
                                    able to use this as before.</span>
                                </div>
                                <div *ngIf="item.isMasterAccount == 1" >
                                    <span class="common-bene-class-for-translation">You are using this username as your primary username. Changing this username you
                                        will no longer be able to use this as before.</span>
                                </div>
                            </div>
                        </div>
                    </ng-container>
                   </ng-container>
                    <ng-template #noData>
                        <div class="flex-row common-bene-class-for-translation">
                            No Data
                        </div>
                    </ng-template>
                </div>
            </div>
            <!---collapseBox1-->
        </div>
        <!---user-name-card card-body---->
    </div>
    
    
    <!--Communication email change open-->
    <div class="main-content">
        <div class="card user-name-card card-body">
            <div class="flex-row bold-bottom-border pb-20">
                <div>
                    <div>
                        <h6 class="common-bene-class-for-translation">Communication Email ID</h6>
                    </div>
                    <div class="un-sub-ttle common-bene-class-for-translation">Update your Communication Email ID for Personal Account</div>
                </div>
                <div class="flex-col align-right">
                    <div class="text-direction-close">
                        <a class="anchor-close" data-toggle="collapse" (click)="toggleView('commEmailBlock')" href="#collapseBox3"
                            role="button">
                            <span class="common-bene-class-for-translation" [ngClass]="{'noDipsplay': commEmailBlockOpen }"> Change</span>
                            <span class="common-bene-class-for-translation" [ngClass]="{'noDipsplay': !commEmailBlockOpen }">Close</span>
                        </a>
                    </div>
                    <div class="last-changed">
                    </div>
                </div>
            </div>
            <div class="collapse" id="collapseBox3">
                <div class="row border-top pb-4" *ngIf="masterAccount">
                    <div class="form-group row pl-0 mt-4 w-100">
                        <div class="col-3">
                        <label><span  class="common-bene-class-for-translation">Communication Email</span></label>
                        <input type="email"  [(ngModel)]="masterAccount.commEmail"
                        class="form-control"
                        placeholder="Communication Email">
                    </div>
                      
                      <div class="col-9 pr-0">
                    <button type="button" class="float-right btn-success button-width-icon-left  btn-content-align btn"
                    (click)="saveUserNamePersonal(masterAccount)">
                    <span class="material-icons  mat-icon" matTooltip="Save Communication Email">save</span>
                    <span class="common-bene-class-for-translation">Save</span>
                </button>
            </div>
            </div>
                </div>
            </div>
            <!---collapseBox2-->
        </div>
        <!---user-name-card card-body---->
    </div>
    <!--Pwd change end-->
    
    <!--Pwd change open-->
    <div class="main-content">
        <div class="card user-name-card card-body">
            <div class="flex-row bold-bottom-border pb-20">
                <div>
                    <div>
                        <h6 class="common-bene-class-for-translation"> Change Password </h6>
                    </div>
                    <div class="un-sub-ttle common-bene-class-for-translation">Choose an unique password to protect your account</div>
                </div>
                <div class="flex-col align-right">
                    <div class="text-direction-close">
                        <a class="anchor-close" data-toggle="collapse" (click)="toggleView('pwdBlock')" href="#collapseBox2"
                            role="button">
                            <span class="common-bene-class-for-translation" [ngClass]="{'noDipsplay': pwdBlockOpen }"> Change</span>
                            <span class="common-bene-class-for-translation" [ngClass]="{'noDipsplay': !pwdBlockOpen }">Close</span>
                        </a>
                    </div>
                    <div class="last-changed">
                    </div>
                </div>
            </div>
            <div class="collapse" id="collapseBox2">
                <div class="row border-top">
                    <app-settings-changepassword></app-settings-changepassword>
                </div>
            </div>
            <!---collapseBox2-->
        </div>
        <!---user-name-card card-body---->
    </div>
    <!--Pwd change end-->
    
</div>